let sgiConstants = {
    // 层叠面板使用
    allWVItemKey: "_allWVItems",

    // 数据与属性交互使用【！！！以下数据为key为开发参数使用，不可修改！！！】
    _checkable: "checkable",//可选
    _disabled: "disabled",//禁用
    _selectable: "selectable",//是否可选
    _draggable: "draggable",//可拖拽
    _disableCheckbox: "disableCheckbox",//禁掉checkbox
    _icon: "icon",//图表
    _checked: "checked",//勾选

    // 操作同步到数据使用，与上面一致
    checked: "_checked",//勾选
};

export default sgiConstants;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiConstants/sgiConstants.js